const stringIsNumber = /^\d+$/;
export const prepareQueryForMainSearch = (value = ''): string => {
  let query = value;
  if (!query) {
    return value;
  }
  if (query.match(stringIsNumber)) {
    return query;
  }
  if ([']', '[', ':', '~'].some((char) => query.includes(char))) {
    return query;
  }
  if (query.includes('_exists_:')) {
    return query;
  }

  if (!['"', '*', ' ', ')'].includes(query[query.length - 1])) {
    query += '*';
  }
  return query;
};
